// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScreenStoneModelMall_main__v8NW5 {
    width: 100%;
    height: 100%;
    cursor: default;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ScreenStoneModelMall_main__v8NW5::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ScreenStoneModelMall_main__v8NW5::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ScreenStoneModelMall_main__v8NW5::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ScreenStoneModelMall_container__LT4wn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 70%;
    padding: 40px 0;
    margin: 0 auto;
}

.ScreenStoneModelMall_container_header__fZeBf {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 24px;
    color: #101417;
}

.ScreenStoneModelMall_container_banner__Ac4PQ {
    width: 100%;
    height: 133px;
    border-radius: 12px;
}

.ScreenStoneModelMall_container_divider__atFL4 {
    width: 100%;
    padding-top: 30px;
    border-bottom: 1px solid #CACFDB;
    margin-bottom: 30px;
}

.ScreenStoneModelMall_container_content__Jupv9 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* height: calc(100% - 100px); */
    height: 805px;
}

.ScreenStoneModelMall_container_content_left__AyX5z,
.ScreenStoneModelMall_container_content_right__5RgpM {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    align-items: center;
    width: 48%;
    /* height: 100%; */
    height: 100%;
}

.ScreenStoneModelMall_container_content_left_header__dPOQ6,
.ScreenStoneModelMall_container_content_right_header__4iFTZ {
    width: 100%;
    height: 36px;
}

.ScreenStoneModelMall_container_content_right_header__4iFTZ {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.ScreenStoneModelMall_header_title__4Mx2j {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    color: #101417;
}

.ScreenStoneModelMall_container_content_left_main__4g\\+Ii {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 750px;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    padding: 20px 0;
}

.ScreenStoneModelMall_container_content_right_main__uqmxY {
    width: 100%;
    height: 750px;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ScreenStoneModelMall_container_content_right_main__uqmxY::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ScreenStoneModelMall_container_content_right_main__uqmxY::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ScreenStoneModelMall_container_content_right_main__uqmxY::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ScreenStoneModelMall_more_box__lzUwu {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 20px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.ScreenStoneModelMall_left_category__FIu4J {
    display: flex;
    width: 100%;
    height: 56px;
    padding: 0 40px 40px;
}

.ScreenStoneModelMall_category_butn__wBrHe {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    padding: 0 16px;
    border-radius: 6px;
    margin-right: 16px;
    font-size: 16px;
    color: #4f4f4f;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.ScreenStoneModelMall_category_butn__wBrHe:hover {
    background-color: #f9f9f9;
}

.ScreenStoneModelMall_category_butn_active__ner6G,
.ScreenStoneModelMall_category_butn_active__ner6G:hover {
    background-color: #17a8b5;
    color: #fff;
}

.ScreenStoneModelMall_left_components__o-iVc {
    width: 100%;
    height: calc(100% - 56px);
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ScreenStoneModelMall_left_components__o-iVc::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ScreenStoneModelMall_left_components__o-iVc::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ScreenStoneModelMall_left_components__o-iVc::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ScreenStoneModelMall_more_text__dT2ap {
    font-size: 14px;
    font-weight: bold;
    color: #17A8B5;
    margin-right: 5px;
}

.ScreenStoneModelMall_more_img__r8Gk2 {
    width: 12px;
    height: 13px;
}

.ScreenStoneModelMall_shopping_model_item__jW1\\+S {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 118px;
    padding: 11px 7px;
    border: 1px solid #D9D9D9;
    margin-bottom: 15px;
    border-radius: 12px;
    background-color: #f9f9f9;
    cursor: pointer;
}

.ScreenStoneModelMall_shopping_model_item__jW1\\+S:hover,
.ScreenStoneModelMall_shopping_model_item_select__eO4hJ {
    border: 1px solid #74BDC6;
}

.ScreenStoneModelMall_shopping_model_img_box__oPd80 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    min-width: 51px;
    height: 51px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #FFF;
}

.ScreenStoneModelMall_shopping_model_img__k-lp7 {
    width: 38px;
    height: 38px;
}

.ScreenStoneModelMall_attached_components_info_box__B7t24 {
    display: flex;
    width: 100%;
    height: 24px;
    margin-bottom: 3px;
}

.ScreenStoneModelMall_attached_components_icon_box__dM4mM {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 100%;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #fff;
    margin-right: 6px;
}

.ScreenStoneModelMall_attached_components_icon_text__wzKWd {
    color: #4f4f4f;
    font-size: 12px;
    font-weight: bold;
    margin-left: 5px;
}

.ScreenStoneModelMall_shopping_model_text_box__M88et {
    flex-grow: 1;
    padding: 0 45px 0 14px;
}

.ScreenStoneModelMall_shopping_model_text_box_unowned__PuVkm {
    padding: 0 10px 0 14px;
}

.ScreenStoneModelMall_shopping_model_text_title__ntgzf {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ScreenStoneModelMall_shopping_model_text_info__IywOr {
    display: -webkit-box;        /* 创建一个弹性盒子 */
    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */
    -webkit-line-clamp: 2;       /* 限制显示两行 */
    overflow: hidden;            /* 隐藏超出内容 */
    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */
    color: #414648;
    font-size: 14px;
    line-height: 20px;
}

.ScreenStoneModelMall_shopping_model_butn__SLU-F {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    border-radius: 6px;
    font-size: 11px;
}

.ScreenStoneModelMall_shopping_model_owned__1uEgN {
    width: 83px;
    min-width: 83px;
    color: #74bdc6;
    background-color: #e4f0f2;
    border: 1px solid #74bdc6;
    border-bottom-width: 2px;
}

.ScreenStoneModelMall_shopping_model_purchase__WKJ3J {
    width: 128px;
    min-width: 128px;
    color: #EABC4E;
    background-color: #FFF;
    border: 1px solid #D9D9D9;
    border-bottom-width: 2px;
}

.ScreenStoneModelMall_model_status_img__8hd1q {
    margin-right: 5px;
}

.ScreenStoneModelMall_right_header_img_box__sXNAW {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 118px;
    margin: 0 auto;
    border-radius: 12px;
    border: 1px solid #e6e6e6;
    margin-top: 25px;
}

.ScreenStoneModelMall_right_header_img__hHAXe {
    width: 100px;
    height: 100px;
}

.ScreenStoneModelMall_right_header_text_box__z7xd3 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.ScreenStoneModelMall_right_header_text__U7rXh {
    color: #101417;
    font-family: "PingFangSCMedium";
    font-size: 18px;
    font-weight: 700;
    margin: 12px;
}

.ScreenStoneModelMall_introduce_box__lszrA,
.ScreenStoneModelMall_example_box__3frFp {
    width: 100%;
    padding: 10px 0;
}

.ScreenStoneModelMall_introduce_title__WRTSh,
.ScreenStoneModelMall_example_title__0mAAB {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 16px;
    color: #101417;
}

.ScreenStoneModelMall_introduce_box__lszrA .ScreenStoneModelMall_attached_components_info_box__B7t24 {
    margin: 10px 0;
}

.ScreenStoneModelMall_introduce_text__1pI6W,
.ScreenStoneModelMall_example_text__j5\\+1w {
    width: 100%;
    padding: 13px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 14px;
    line-height: 16px;
    color: #414648;
}

.ScreenStoneModelMall_example_text__j5\\+1w img {
    max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ScreenStoneModelMall/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,sDAA0B,UAAU;IAChC,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,4DAAgC,WAAW;IACvC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;IACV,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,8EAAkD,UAAU;IACxD,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,oFAAwD,WAAW;IAC/D,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,iEAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,uEAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB,SAAS,aAAa;IAC1C,4BAA4B,EAAE,oBAAoB;IAClD,qBAAqB,QAAQ,WAAW;IACxC,gBAAgB,aAAa,WAAW;IACxC,uBAAuB,MAAM,iBAAiB;IAC9C,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n    cursor: default;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.main::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.main::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.main::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 70%;\n    padding: 40px 0;\n    margin: 0 auto;\n}\n\n.container_header {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: 50px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 24px;\n    color: #101417;\n}\n\n.container_banner {\n    width: 100%;\n    height: 133px;\n    border-radius: 12px;\n}\n\n.container_divider {\n    width: 100%;\n    padding-top: 30px;\n    border-bottom: 1px solid #CACFDB;\n    margin-bottom: 30px;\n}\n\n.container_content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    /* height: calc(100% - 100px); */\n    height: 805px;\n}\n\n.container_content_left,\n.container_content_right {\n    display: flex;\n    flex-direction: column;\n    /* justify-content: space-between; */\n    align-items: center;\n    width: 48%;\n    /* height: 100%; */\n    height: 100%;\n}\n\n.container_content_left_header,\n.container_content_right_header {\n    width: 100%;\n    height: 36px;\n}\n\n.container_content_right_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.header_title {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 20px;\n    color: #101417;\n}\n\n.container_content_left_main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: 750px;\n    border: 1px solid #D9D9D9;\n    border-radius: 12px;\n    padding: 20px 0;\n}\n\n.container_content_right_main {\n    width: 100%;\n    height: 750px;\n    border: 1px solid #D9D9D9;\n    border-radius: 12px;\n    padding: 20px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container_content_right_main::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.container_content_right_main::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container_content_right_main::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.more_box {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    height: 20px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.left_category {\n    display: flex;\n    width: 100%;\n    height: 56px;\n    padding: 0 40px 40px;\n}\n\n.category_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 32px;\n    padding: 0 16px;\n    border-radius: 6px;\n    margin-right: 16px;\n    font-size: 16px;\n    color: #4f4f4f;\n    cursor: pointer;\n    user-select: none;\n}\n\n.category_butn:hover {\n    background-color: #f9f9f9;\n}\n\n.category_butn_active,\n.category_butn_active:hover {\n    background-color: #17a8b5;\n    color: #fff;\n}\n\n.left_components {\n    width: 100%;\n    height: calc(100% - 56px);\n    padding: 0 20px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.left_components::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.left_components::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.left_components::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.more_text {\n    font-size: 14px;\n    font-weight: bold;\n    color: #17A8B5;\n    margin-right: 5px;\n}\n\n.more_img {\n    width: 12px;\n    height: 13px;\n}\n\n.shopping_model_item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 118px;\n    padding: 11px 7px;\n    border: 1px solid #D9D9D9;\n    margin-bottom: 15px;\n    border-radius: 12px;\n    background-color: #f9f9f9;\n    cursor: pointer;\n}\n\n.shopping_model_item:hover,\n.shopping_model_item_select {\n    border: 1px solid #74BDC6;\n}\n\n.shopping_model_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 51px;\n    min-width: 51px;\n    height: 51px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #FFF;\n}\n\n.shopping_model_img {\n    width: 38px;\n    height: 38px;\n}\n\n.attached_components_info_box {\n    display: flex;\n    width: 100%;\n    height: 24px;\n    margin-bottom: 3px;\n}\n\n.attached_components_icon_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 100%;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #fff;\n    margin-right: 6px;\n}\n\n.attached_components_icon_text {\n    color: #4f4f4f;\n    font-size: 12px;\n    font-weight: bold;\n    margin-left: 5px;\n}\n\n.shopping_model_text_box {\n    flex-grow: 1;\n    padding: 0 45px 0 14px;\n}\n\n.shopping_model_text_box_unowned {\n    padding: 0 10px 0 14px;\n}\n\n.shopping_model_text_title {\n    width: 100%;\n    height: 28px;\n    line-height: 28px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.shopping_model_text_info {\n    display: -webkit-box;        /* 创建一个弹性盒子 */\n    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */\n    -webkit-line-clamp: 2;       /* 限制显示两行 */\n    overflow: hidden;            /* 隐藏超出内容 */\n    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */\n    color: #414648;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.shopping_model_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 28px;\n    border-radius: 6px;\n    font-size: 11px;\n}\n\n.shopping_model_owned {\n    width: 83px;\n    min-width: 83px;\n    color: #74bdc6;\n    background-color: #e4f0f2;\n    border: 1px solid #74bdc6;\n    border-bottom-width: 2px;\n}\n\n.shopping_model_purchase {\n    width: 128px;\n    min-width: 128px;\n    color: #EABC4E;\n    background-color: #FFF;\n    border: 1px solid #D9D9D9;\n    border-bottom-width: 2px;\n}\n\n.model_status_img {\n    margin-right: 5px;\n}\n\n.right_header_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 118px;\n    height: 118px;\n    margin: 0 auto;\n    border-radius: 12px;\n    border: 1px solid #e6e6e6;\n    margin-top: 25px;\n}\n\n.right_header_img {\n    width: 100px;\n    height: 100px;\n}\n\n.right_header_text_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_header_text {\n    color: #101417;\n    font-family: \"PingFangSCMedium\";\n    font-size: 18px;\n    font-weight: 700;\n    margin: 12px;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    padding: 10px 0;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 16px;\n    color: #101417;\n}\n\n.introduce_box .attached_components_info_box {\n    margin: 10px 0;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 13px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 14px;\n    line-height: 16px;\n    color: #414648;\n}\n\n.example_text img {\n    max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ScreenStoneModelMall_main__v8NW5`,
	"container": `ScreenStoneModelMall_container__LT4wn`,
	"container_header": `ScreenStoneModelMall_container_header__fZeBf`,
	"container_banner": `ScreenStoneModelMall_container_banner__Ac4PQ`,
	"container_divider": `ScreenStoneModelMall_container_divider__atFL4`,
	"container_content": `ScreenStoneModelMall_container_content__Jupv9`,
	"container_content_left": `ScreenStoneModelMall_container_content_left__AyX5z`,
	"container_content_right": `ScreenStoneModelMall_container_content_right__5RgpM`,
	"container_content_left_header": `ScreenStoneModelMall_container_content_left_header__dPOQ6`,
	"container_content_right_header": `ScreenStoneModelMall_container_content_right_header__4iFTZ`,
	"header_title": `ScreenStoneModelMall_header_title__4Mx2j`,
	"container_content_left_main": `ScreenStoneModelMall_container_content_left_main__4g+Ii`,
	"container_content_right_main": `ScreenStoneModelMall_container_content_right_main__uqmxY`,
	"more_box": `ScreenStoneModelMall_more_box__lzUwu`,
	"left_category": `ScreenStoneModelMall_left_category__FIu4J`,
	"category_butn": `ScreenStoneModelMall_category_butn__wBrHe`,
	"category_butn_active": `ScreenStoneModelMall_category_butn_active__ner6G`,
	"left_components": `ScreenStoneModelMall_left_components__o-iVc`,
	"more_text": `ScreenStoneModelMall_more_text__dT2ap`,
	"more_img": `ScreenStoneModelMall_more_img__r8Gk2`,
	"shopping_model_item": `ScreenStoneModelMall_shopping_model_item__jW1+S`,
	"shopping_model_item_select": `ScreenStoneModelMall_shopping_model_item_select__eO4hJ`,
	"shopping_model_img_box": `ScreenStoneModelMall_shopping_model_img_box__oPd80`,
	"shopping_model_img": `ScreenStoneModelMall_shopping_model_img__k-lp7`,
	"attached_components_info_box": `ScreenStoneModelMall_attached_components_info_box__B7t24`,
	"attached_components_icon_box": `ScreenStoneModelMall_attached_components_icon_box__dM4mM`,
	"attached_components_icon_text": `ScreenStoneModelMall_attached_components_icon_text__wzKWd`,
	"shopping_model_text_box": `ScreenStoneModelMall_shopping_model_text_box__M88et`,
	"shopping_model_text_box_unowned": `ScreenStoneModelMall_shopping_model_text_box_unowned__PuVkm`,
	"shopping_model_text_title": `ScreenStoneModelMall_shopping_model_text_title__ntgzf`,
	"shopping_model_text_info": `ScreenStoneModelMall_shopping_model_text_info__IywOr`,
	"shopping_model_butn": `ScreenStoneModelMall_shopping_model_butn__SLU-F`,
	"shopping_model_owned": `ScreenStoneModelMall_shopping_model_owned__1uEgN`,
	"shopping_model_purchase": `ScreenStoneModelMall_shopping_model_purchase__WKJ3J`,
	"model_status_img": `ScreenStoneModelMall_model_status_img__8hd1q`,
	"right_header_img_box": `ScreenStoneModelMall_right_header_img_box__sXNAW`,
	"right_header_img": `ScreenStoneModelMall_right_header_img__hHAXe`,
	"right_header_text_box": `ScreenStoneModelMall_right_header_text_box__z7xd3`,
	"right_header_text": `ScreenStoneModelMall_right_header_text__U7rXh`,
	"introduce_box": `ScreenStoneModelMall_introduce_box__lszrA`,
	"example_box": `ScreenStoneModelMall_example_box__3frFp`,
	"introduce_title": `ScreenStoneModelMall_introduce_title__WRTSh`,
	"example_title": `ScreenStoneModelMall_example_title__0mAAB`,
	"introduce_text": `ScreenStoneModelMall_introduce_text__1pI6W`,
	"example_text": `ScreenStoneModelMall_example_text__j5+1w`
};
export default ___CSS_LOADER_EXPORT___;
